import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OneDxMaterialItem } from '../../shared/models/onedx.model';

export interface InstrumentOnlyForm {
    productLine: string;
    soldTo: string;
    shipTo: string;
    materials: OneDxMaterialItem[];
}

export interface InstrumentOnlyFormGroup {
    productLine: FormControl<string | null>;
    soldTo: FormControl<string | null>;
    shipTo: FormControl<string | null>;
    materials: FormControl<OneDxMaterialItem[]>;
}

export const createInstrumentOnlyFormGroup = (): FormGroup<InstrumentOnlyFormGroup> => {
    return new FormGroup<InstrumentOnlyFormGroup>({
        productLine: new FormControl<string | null>(null, Validators.required),
        soldTo: new FormControl<string | null>(null),
        shipTo: new FormControl<string | null>(null),
        materials: new FormControl<OneDxMaterialItem[]>([], { nonNullable: true })
    });
};
